import {combineReducers} from 'redux';
import userReducer from './user';
import configReducer from './config';
import showReducer from './show';
import episodeReducer from './episode';
import movieReducer from './movie';
import favouriteReducer from './favourite';
import recommendationReducer from './recommendation';
import drmReducer from './drm';
import videoReducer from './video';
import toast from './toast';
import modal from './modal';

export default combineReducers({
    config: configReducer,
    user: userReducer,
    show: showReducer,
    episode: episodeReducer,
    movie: movieReducer,
    favourite: favouriteReducer,
    recommendation: recommendationReducer,
    drm: drmReducer,
    video: videoReducer,
    ui: combineReducers({
        toast,
        modal,
    }),
});

export const getHomeData = state => state.home.rows;
export const getHomeLoading = state => state.home.loading;
export const getHomeError = state => state.home.error;
